import React, { useEffect, useState } from "react";
import contactImg from "../img/Contact-Us.png";
import "../css/home.css";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
function Contact() {
  
  // Intersection Observer for fade-up animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("show");
        });
      },
      { threshold: 0.3 }
    );

    const elements = document.querySelectorAll(".fade-up");
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

 
  return (
    <div className="contact-section py-5">
      <div className="container">
        <div className="row align-items-center">

          {/* Left Column: Contact Form */}
          <div className="col-lg-6 mb-4">
            <div className="contact-card p-4 shadow-lg rounded fade-up">
              <h2 className="mb-4 text-primary">Get in Touch</h2>
              <p className="mb-4 text-muted">
                We'd love to hear from you! Fill out the form and we'll get back to you soon.<br /><br />
                At NeatNest, we believe easy communication is the first step toward exceptional service. Whether you have a question, need a custom cleaning plan, or want to book a service, our team is always ready to assist you. We make it simple and convenient to connect with us for all your home cleaning needs. Reach out to our friendly support team for quick responses, clear guidance, and reliable assistance. From service inquiries and scheduling to feedback and support, we ensure a smooth and hassle-free experience. At NeatNest, your comfort and satisfaction matter to us, and we’re always just a message or call away to help keep your home clean, fresh, and stress-free.
              </p><br />
              <Link  to="/contact"  className="service-btn d-inline-flex align-items-center gap-2">Contact Us
                  <FaArrowRight />
                </Link>


           
            </div>
          </div>

          {/* Right Column: Image */}
          <div className="col-lg-6 fade-up">
            <div className="contact-image overflow-hidden rounded shadow">
              <img
                src={contactImg}
                alt="Contact Us"
                className="img-fluid"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Contact;
